import { type Reducer } from "redux"
import { CreditCardActionTypes, type CreditCardActions, type FetchAllCardsAction, type SetShouldRefetchCardsAction } from "../actions/creditCard/creditCardTypes"

export interface CreditCardState {
    items: Array<any>
    totalPages: number
    totalDocs: number
    itemsPerPage: number
    currentPage: number
    shouldRefetch: boolean
}

const initialState = {
    items: [],
    itemsPerPage: 10,
    currentPage: 1,
    totalPages: 0,
    totalDocs: 0,
    shouldRefetch: false,
}

const fetchAllCards = (state: CreditCardState, { cards, totalPages, totalDocs, append }: FetchAllCardsAction): CreditCardState => {
    return {
        ...state,
        items: !append ? cards : [...state.items, ...cards],
        totalPages,
        totalDocs,
    }
}

const setShouldRefetch = (state: CreditCardState, action: SetShouldRefetchCardsAction): CreditCardState => ({
    ...state,
    shouldRefetch: action.shouldRefetch,
})

export const creditCardReducer: Reducer<CreditCardState, CreditCardActions> = (state = initialState, action) => {
    switch (action.type) {
        case CreditCardActionTypes.FETCH_ALL_CARDS:
            return fetchAllCards(state, action)
        case CreditCardActionTypes.SET_SHOULD_REFETCH_CARDS:
            return setShouldRefetch(state, action)
        default:
            return state
    }
}
